import React from 'react';
import { notifications } from '../data/mockData';

const NotificationPanel: React.FC = () => {
  // Fonction pour formater la date
  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('fr-FR', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  // Fonction pour obtenir l'icône en fonction du type de notification
  const getNotificationIcon = (type: string) => {
    switch(type) {
      case 'sms_sent':
        return (
          <div className="flex-shrink-0 bg-blue-100 rounded-full p-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
            </svg>
          </div>
        );
      case 'weight_update':
        return (
          <div className="flex-shrink-0 bg-green-100 rounded-full p-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
            </svg>
          </div>
        );
      case 'delivery_complete':
        return (
          <div className="flex-shrink-0 bg-purple-100 rounded-full p-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        );
      case 'delay':
        return (
          <div className="flex-shrink-0 bg-yellow-100 rounded-full p-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        );
      default:
        return (
          <div className="flex-shrink-0 bg-gray-100 rounded-full p-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        );
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="bg-blue-800 text-white px-4 py-3 flex justify-between items-center">
        <h3 className="font-semibold">Notifications récentes</h3>
        <span className="bg-blue-700 text-xs font-medium px-2 py-1 rounded-full">
          {notifications.length} nouvelles
        </span>
      </div>
      
      <div className="divide-y divide-gray-200 max-h-96 overflow-y-auto">
        {notifications.map((notification) => (
          <div key={notification.id} className="p-4 hover:bg-gray-50 transition-colors">
            <div className="flex space-x-3">
              {getNotificationIcon(notification.type)}
              
              <div className="flex-1 space-y-1">
                <div className="flex items-center justify-between">
                  <h3 className="text-sm font-medium">Livraison #{notification.deliveryId}</h3>
                  <p className="text-xs text-gray-500">{formatTime(notification.timestamp)}</p>
                </div>
                <p className="text-sm text-gray-600">{notification.message}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="bg-gray-50 px-4 py-3 text-center">
        <button className="text-sm text-blue-600 hover:text-blue-800 font-medium">
          Voir toutes les notifications
        </button>
      </div>
    </div>
  );
};

export default NotificationPanel;
